import React from 'react';

import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import { FiberManualRecord } from '@material-ui/icons';
import { Skeleton } from '@material-ui/lab';

import { toLocaleString } from '../../utils/format-number';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: '1px solid #00000014',
    borderRadius: '12px',
    padding: theme.spacing(2),
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
  },
  itemRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
    height: '10px',
    width: '10px',
  },
  itemText: {
    display: 'flex',
    alignItems: 'center',
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#0000000D',
    margin: theme.spacing(1, 0),
  },
}));

interface SummaryCardProps {
  isFetching?: boolean;
  cardHeading?: string;
  totalModels: number;
  totalFreelancers: number;
  selectedLabel?: string;
}

export const SummaryCard: React.FC<SummaryCardProps> = ({
  isFetching = false,
  cardHeading,
  totalModels,
  totalFreelancers,
  selectedLabel = '',
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box display={'flex'} alignItems={'flex-end'} mb={2} justifyContent={'space-between'}>
        <Typography style={{ fontSize: '15px', margin: 0 }}>
          {cardHeading}&nbsp;
          <Typography component={'span'} style={{ fontWeight: 500 }}>
            {toLocaleString(totalModels + totalFreelancers)}
          </Typography>
        </Typography>
        <Typography style={{ fontSize: '13px', margin: 0, color: 'rgba(0, 0, 0, 0.50)' }}>
          {selectedLabel}
        </Typography>
      </Box>
      <Box className={classes.itemRow}>
        <Box className={classes.itemText}>
          <FiberManualRecord className={classes.icon} style={{ color: '#FCC584' }} />
          <Typography
            variant="body2"
            style={{
              fontSize: '13px',
              fontFamily: 'Poppins',
              fontWeight: 400,
              lineHeight: '19.5px',
            }}
          >
            Models
          </Typography>
        </Box>
        {isFetching && (
          <Skeleton
            animation="wave"
            variant="rect"
            width={50}
            height={10}
            style={{ marginTop: '5px', borderRadius: '5px' }}
          />
        )}
        {!isFetching && (
          <Typography variant="body2">
            <span
              style={{
                fontSize: '15px',
                fontFamily: 'Poppins',
                fontWeight: 500,
                color: '#111111',
              }}
            >
              {toLocaleString(totalModels)}
            </span>
          </Typography>
        )}
      </Box>
      <div className={classes.divider}></div>
      <Box className={classes.itemRow}>
        <Box className={classes.itemText}>
          <FiberManualRecord className={classes.icon} style={{ color: '#BEDEC5' }} />
          <Typography
            variant="body2"
            style={{
              fontSize: '13px',
              fontFamily: 'Poppins',
              fontWeight: 400,
              lineHeight: '19.5px',
            }}
          >
            Freelancer
          </Typography>
        </Box>
        {isFetching && (
          <Skeleton
            animation="wave"
            variant="rect"
            width={50}
            height={10}
            style={{ marginTop: '5px', borderRadius: '5px' }}
          />
        )}
        {!isFetching && (
          <Typography variant="body2">
            <span
              style={{
                fontSize: '15px',
                fontFamily: 'Poppins',
                fontWeight: 500,
                color: '#111111',
              }}
            >
              {toLocaleString(totalFreelancers)}
            </span>
          </Typography>
        )}
      </Box>
      <div className={classes.divider}></div>
    </Box>
  );
};
